import { React, useEffect, useState } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

function Report() {
	return (
            <iframe 
                src="https://ee-kbt.openup.org.za/x/f7h9xzoF/?Province_Name=FS" 
                width="100%" 
                height="1000px" 
                frameborder="0">
            </iframe>
	);
}

export default Report;